import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  Divider,
  Chip,
  Stack,
} from '@mui/material';
import moment from 'moment';

import { CloseTwoTone, SaveTwoTone, SearchRounded } from '@mui/icons-material';
import { useAuthState } from '../../../../contexts/AuthContext';
import apiCep from '../../../../api/apiCep';
import { toast } from 'react-toastify';
import { useRef } from 'react';
import { validaCNPJ, validaCPF } from '../../../../helpers/HelperFunctions';
import api from '../../../../api/api';

export default function ModalClientes({
  open,
  onClose,
  clienteSelecionado,
  inserirCliente,
  alterarCliente,
  ultimaVenda,
}) {
  const { usuarioIDLogado, empresaAtiva } = useAuthState();
  const [cliente, setCliente] = useState([
    {
      codigo_cliente: '0',
      razao_social: '',
      tipo: 'JURÍDICO',
      nome_fantasia: '',
      cep: '',
      endereco: '',
      numero: '',
      bairro: '',
      complemento: '',
      telefones: '',
      estado: '',
      cidade: '',
      entrega: '',
      ins_estadual: '',
      cnpj: '',
      contato: '',
      ultCompra: '',
      e_mail: '',
      whatsapp: '',
      cod_vendedor: usuarioIDLogado,
      app: 'SIM',
    },
  ]);
  const [camposComErro, setCamposComErro] = useState({
    razao_social: false,
    tipo: false,
    nome_fantasia: false,
    cep: false,
    endereco: false,
    numero: false,
    bairro: false,
    entrega: false,
    complemento: false,
    telefones: false,
    estado: false,
    cidade: false,
    ins_estadual: false,
    cnpj: false,
    contato: false,
    ultCompra: false,
    e_mail: false,
    whatsapp: false,
  });

  const refCampoCep = useRef('refCampoCep');
  const refCampoNumero = useRef('refCampoNumero');

  useEffect(() => {
    if (clienteSelecionado) {
      if (clienteSelecionado.length === 0) {
        setCliente({
          codigo_cliente: '0',
          razao_social: '',
          tipo: 'JURÍDICO',
          nome_fantasia: '',
          cep: '',
          endereco: '',
          numero: '',
          bairro: '',
          complemento: '',
          telefones: '',
          estado: '',
          cidade: '',
          ins_estadual: '',
          cnpj: '',
          contato: '',
          ultimaVenda: '',
          entrega: '',
          whatsapp: '',
          ultCompra: '',
          e_mail: '',
          cod_vendedor: usuarioIDLogado,
          app: 'SIM',
        });
      } else {
        setCliente({
          codigo_cliente: clienteSelecionado.codigo_cliente,
          razao_social: clienteSelecionado.razao_social,
          tipo: clienteSelecionado.tipo,
          nome_fantasia: clienteSelecionado.nome_fantasia,
          cep: clienteSelecionado.cep,
          endereco: clienteSelecionado.endereco,
          numero: clienteSelecionado.numero,
          bairro: clienteSelecionado.bairro,
          complemento: clienteSelecionado.complemento,
          telefones: clienteSelecionado.telefones,
          telefone1: clienteSelecionado.telefone1,
          estado: clienteSelecionado.estado,
          cidade: clienteSelecionado.cidade,
          entrega: clienteSelecionado.cli_end_entrega,
          ins_estadual: clienteSelecionado.ins_estadual,
          ultCompra: ultimaVenda ? clienteSelecionado.ultCompra : '',
          cnpj: clienteSelecionado.cnpj,
          contato: clienteSelecionado.contato,
          e_mail: clienteSelecionado.e_mail,
          cod_vendedor: usuarioIDLogado,
          app: 'SIM',
        });
      }
    }
  }, [clienteSelecionado]);

  const salvarDados = () => {
    if (validaCliente() === true) {
      if (cliente.codigo_cliente !== '0') {
        alterarCliente(cliente);
      } else {
        inserirCliente(cliente);
      }
    } else {
      toast.error('Preencha todos os dados do cliente corretamente');
    }
  };

  function validaCliente() {
    if (
      cliente.tipo &&
      cliente.razao_social &&
      cliente.nome_fantasia &&
      cliente.cnpj &&
      cliente.cep &&
      cliente.endereco &&
      cliente.numero &&
      cliente.bairro &&
      cliente.cidade &&
      cliente.estado &&
      cliente.telefones
    ) {
      if (cliente.tipo === 'FÍSICO' && validaCPF(cliente.cnpj) === true) {
        return true;
      } else if (
        cliente.tipo === 'JURÍDICO' &&
        validaCNPJ(cliente.cnpj) === true
      ) {
        return true;
      }
    }
  }

  const handleChange = (prop) => (event) => {
    setCliente({ ...cliente, [prop]: event.target.value.toUpperCase() });
  };

  async function handleSearchCep() {
    if (cliente.cep) {
      await apiCep
        .get(`${cliente.cep}/json`)
        .then(({ data }) => {
          if (data.erro) {
            toast.error('CEP NÃO ENCONTRADO');
          } else {
            setCliente({
              ...cliente,

              endereco: data.logradouro.toUpperCase(),
              bairro: data.bairro.toUpperCase(),
              cidade: data.localidade.toUpperCase(),
              estado: data.uf.toUpperCase(),
            });
            setCamposComErro({ ...camposComErro, cep: false });
            refCampoNumero.current.focus();
          }
        })
        .catch((err) => {
          toast.error('erro' + err.message);
          refCampoCep.current.focus();
          setCamposComErro({ ...camposComErro, cep: true });
        });
    } else {
      toast.error('Digite o CEP');
      refCampoCep.current.focus();
      setCamposComErro({ ...camposComErro, cep: true });
    }
  }
  function confereCPFCNPJ(e) {
    if (cliente.tipo === 'JURÍDICO' && validaCNPJ(e.target.value) === false) {
      toast.warning('Atenção CNPJ inválido.');
      setCamposComErro({ ...camposComErro, cnpj: true });
    } else if (
      cliente.tipo === 'FÍSICO' &&
      validaCPF(e.target.value) === false
    ) {
      toast.warning('Atenção CPF inválido.');
      setCamposComErro({ ...camposComErro, cnpj: true });
    } else {
      setCamposComErro({ ...camposComErro, cnpj: false });
    }
  }

  function validaCampos(campo) {
    if (cliente[campo] === '') {
      setCamposComErro({ ...camposComErro, [campo]: true });
    } else {
      setCamposComErro({ ...camposComErro, [campo]: false });
    }
  }

  async function confereCadastroCnpj(cnpj) {
    if (cliente.cnpj) {
      try {
        const { data } = await api.post(
          '/clientes/verificarCnpj',
          { cnpj: cnpj },
          {
            headers: { banco: empresaAtiva },
          }
        );
        if (data) {
          toast.error('CNPJ JÁ CADASTRADO ');
        } else {
          toast.success('CNPJ não cadastrado');
        }
      } catch {
        toast.error('Erro ao buscar dados ');
      } finally {
      }
    } else {
      toast.warning('CNPJ deve ser preenchido!');
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="Cadastro de Clientes"
      aria-describedby="Cadastro de Clientes"
      hideBackdrop
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: {
            xs: '95%',
            sm: '95%',
            md: '95%',
            lg: '90%',
            xl: '50%',
            xxl: '30%',
          },
          height: {
            xs: '95%',
            sm: '95%',
            md: '60%',
            lg: '80%',
            xl: '70%',
            xxl: '85%',
          },
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 2,
          borderRadius: 5,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: ' column',
            justifyContent: 'space-between',
            height: '100%',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid',
              marginBottom: '1.5%',
            }}
          >
            <Typography variant="h6">Cadastro Clientes</Typography>

            <IconButton
              onClick={() => {
                onClose();
              }}
            >
              <CloseTwoTone sx={{ color: 'primary.error' }} />
            </IconButton>
          </Box>
          <Box>
            <Divider>
              <Chip label="Dados do Cliente" size="small" />
            </Divider>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                width: '100%',
                mt: 1,
                mb: 1,
              }}
            >
              <FormControl
                sx={{
                  mb: { xs: 1 },
                  width: {
                    xs: '100%',
                    sm: '100%',
                    md: '10%',
                    lg: '7%',
                    xl: '7%',
                  },
                }}
              >
                <TextField
                  size="small"
                  value={cliente.codigo_cliente}
                  label={'Código'}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '100%',
                    sm: '70%',
                    md: '13%',
                    lg: '13%',
                    xl: '13%',
                  },
                  marginLeft: { xs: '0%', sm: '3%', md: '1%', lg: '1%' },
                }}
              >
                <InputLabel id="tipoCliente">Tipo Cliente</InputLabel>
                <Select
                  id="tipoCliente"
                  error={camposComErro.tipo}
                  label="Tipo Cliente"
                  onChange={handleChange('tipo')}
                  size="small"
                  fullWidth
                  value={cliente.tipo}
                >
                  <MenuItem value="">SELECIONE UMA OPÇÃO</MenuItem>
                  <MenuItem value="JURÍDICO">JURÍDICO</MenuItem>
                  <MenuItem value="FÍSICO">FÍSICO</MenuItem>
                </Select>
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '100%',
                    sm: '100%',
                    md: '38%',
                    lg: '38%',
                    xl: '38%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '0' },
                  marginLeft: { xs: '0', sm: '0', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  value={cliente.razao_social}
                  onChange={handleChange('razao_social')}
                  error={camposComErro.razao_social}
                  size="small"
                  label="Razão Social"
                  onBlur={() => validaCampos('razao_social')}
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '100%',
                    sm: '100%',
                    md: '36%',
                    lg: '38%',
                    xl: '38%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '0' },
                  marginLeft: { xs: '0', sm: '0', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  value={cliente.nome_fantasia}
                  onChange={handleChange('nome_fantasia')}
                  error={camposComErro.nome_fantasia}
                  size="small"
                  label="Nome Fantasia"
                  onBlur={() => validaCampos('nome_fantasia')}
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '45%',
                    sm: '45%',
                    md: '20%',
                    lg: '20%',
                    xl: '20%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '0', sm: '0', md: '0%', lg: '0%' },
                }}
              >
                <TextField
                  onChange={handleChange('cnpj')}
                  value={cliente.cnpj}
                  error={camposComErro.cnpj}
                  size="small"
                  label={cliente.tipo === 'JURÍDICO' ? 'CNPJ' : 'CPF'}
                  onBlur={(e) => confereCPFCNPJ(e)}
                />
              </FormControl>
              <FormControl
                sx={{
                  width: { xs: '5%', sm: '2%', md: '2%', lg: '2%', xl: '2%' },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '1%', sm: '1%', md: '1%', lg: '1%' },
                }}
              >
                <IconButton
                  bgcolor="info"
                  color="success"
                  onClick={() => confereCadastroCnpj(cliente.cnpj)}
                >
                  <SearchRounded />
                </IconButton>
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '45%',
                    sm: '45%',
                    md: '20%',
                    lg: '20%',
                    xl: '20%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '3%', sm: '3%', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  onChange={handleChange('ins_estadual')}
                  value={cliente.ins_estadual}
                  error={camposComErro.ins_estadual}
                  size="small"
                  label={cliente.tipo === 'JURÍDICO' ? 'INSC. ESTADUAL' : 'R.G'}
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '100%',
                    sm: '100%',
                    md: '22%',
                    lg: '22%',
                    xl: '22%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '0%', sm: '3%', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  value={
                    cliente.ultCompra
                      ? moment(cliente.ultCompra).format('DD/MM/YYYY')
                      : ''
                  }
                  disabled
                  size="small"
                  label="ULTIMA COMPRA"
                />
              </FormControl>
            </Box>
            <Divider>
              <Chip label="Endereço" size="small" />
            </Divider>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                width: '100%',
                mt: '0%',
                mb: '1%',
              }}
            >
              <FormControl
                sx={{
                  width: {
                    xs: '30%',
                    sm: '30%',
                    md: '10%',
                    lg: '10%',
                    xl: '10%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '0', sm: '0', md: '0', lg: '0' },
                }}
              >
                <TextField
                  onChange={handleChange('cep')}
                  value={cliente.cep}
                  error={camposComErro.cep}
                  size="small"
                  label="C.E.P"
                  inputRef={refCampoCep}
                  onBlur={() => handleSearchCep(cliente.cep)}
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '67%',
                    sm: '60%',
                    md: '44%',
                    lg: '44%',
                    xl: '44%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '3%', sm: '0', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  onChange={handleChange('endereco')}
                  value={cliente.endereco}
                  size="small"
                  label="ENDEREÇO"
                  onBlur={() => validaCampos('endereco')}
                  error={camposComErro.endereco}
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '30%',
                    sm: '30%',
                    md: '15%',
                    lg: '15%',
                    xl: '15%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '0', sm: '0', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  onChange={handleChange('numero')}
                  value={cliente.numero}
                  error={camposComErro.numero}
                  onBlur={() => validaCampos('numero')}
                  size="small"
                  label="NÚMERO"
                  inputRef={refCampoNumero}
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '67%',
                    sm: '67%',
                    md: '25%',
                    lg: '28%',
                    xl: '28%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '3%', sm: '0', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  onChange={handleChange('complemento')}
                  value={cliente.complemento}
                  error={camposComErro.complemento}
                  size="small"
                  label="COMPLEMENTO"
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '100%',
                    sm: '100%',
                    md: '25%',
                    lg: '35%',
                    xl: '35%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '0', sm: '0', md: '0%', lg: '0%' },
                }}
              >
                <TextField
                  onChange={handleChange('bairro')}
                  value={cliente.bairro}
                  error={camposComErro.bairro}
                  onBlur={() => validaCampos('bairro')}
                  size="small"
                  label="BAIRRO"
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '70%',
                    sm: '70%',
                    md: '32%',
                    lg: '45%',
                    xl: '45%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '0', sm: '0', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  onChange={handleChange('cidade')}
                  value={cliente.cidade}
                  onBlur={() => validaCampos('cidade')}
                  error={camposComErro.cidade}
                  size="small"
                  label="CIDADE"
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '27%',
                    sm: '27%',
                    md: '15%',
                    lg: '18%',
                    xl: '18%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: {
                    xs: '3%',
                    sm: '3%',
                    md: '0%',
                    lg: '1%',
                    xl: '1%',
                  },
                }}
              >
                <TextField
                  onChange={handleChange('estado')}
                  value={cliente.estado}
                  error={camposComErro.estado}
                  onBlur={() => validaCampos('estado')}
                  size="small"
                  label="U.F"
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '100%',
                    sm: '100%',
                    md: '100%',
                    lg: '100%',
                    xl: '100%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '0%', sm: '0%', md: '0%', lg: '0%' },
                }}
              >
                <TextField
                  onChange={handleChange('entrega')}
                  value={cliente.entrega}
                  error={camposComErro.entrega}
                  size="small"
                  label="ENTREGA"
                  fullWidth
                />
              </FormControl>
            </Box>
            <Divider>
              <Chip label="Contato" size="small" />
            </Divider>
            <Box sx={{ mt: '1%' }}>
              <FormControl
                sx={{
                  width: {
                    xs: '48%',
                    sm: '45%',
                    md: '30%',
                    lg: '25%',
                    xl: '25%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '0%', sm: '0%', md: '0%', lg: '0%' },
                }}
              >
                <TextField
                  onChange={handleChange('e_mail')}
                  value={cliente.e_mail}
                  error={camposComErro.email}
                  size="small"
                  label="EMAIL"
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '48%',
                    sm: '48%',
                    md: '22%',
                    lg: '23%',
                    xl: '23%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '3%', sm: '3%', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  onChange={handleChange('telefones')}
                  value={cliente.telefones}
                  error={camposComErro.telefones}
                  onBlur={() => validaCampos('telefones')}
                  size="small"
                  label="TELEFONE"
                />
              </FormControl>

              <FormControl
                sx={{
                  width: {
                    xs: '100%',
                    sm: '100%',
                    md: '30%',
                    lg: '23%',
                    xl: '23%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '0%', sm: '0%', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  onChange={handleChange('contato')}
                  value={cliente.contato}
                  error={camposComErro.contato}
                  onBlur={() => validaCampos('contato')}
                  size="small"
                  label="CONTATO"
                  fullWidth
                />
              </FormControl>
              <FormControl
                sx={{
                  width: {
                    xs: '100%',
                    sm: '100%',
                    md: '30%',
                    lg: '23%',
                    xl: '23%',
                  },
                  marginTop: { xs: '3%', sm: '3%', md: '1%' },
                  marginLeft: { xs: '0%', sm: '0%', md: '1%', lg: '1%' },
                }}
              >
                <TextField
                  onChange={handleChange('telefone1')}
                  value={cliente.telefone1}
                  error={camposComErro.telefone1}
                  onBlur={() => validaCampos('telefone1')}
                  size="small"
                  label="WHATSAPP"
                  fullWidth
                />
              </FormControl>
            </Box>
          </Box>
          <Stack
            direction="row"
            alignItems="flex-end"
            justifyContent="flex-end"
            mt={{ lg: 15, sm: 5, xl: 5, xxl: 0 }}
          >
            <Button
              onClick={() => salvarDados(cliente)}
              startIcon={<SaveTwoTone />}
              sx={{
                mt: { xs: 2 },
                height: {
                  xs: '40px',
                  sm: '40px',
                  md: '50px',
                  lg: '50px',
                  xl: '50px',
                },
                width: {
                  xs: '120px',
                  sm: '120px',
                  md: '130px',
                  lg: '180px',
                  xl: '180px',
                },
                borderRadius: '20px',
                fontSize: {
                  xs: '1rem',
                  sm: '1.1rem',
                  md: '1.2rem',
                  lg: '1.3rem',
                  xl: '1.4rem',
                },
              }}
              variant="contained"
            >
              SALVAR
            </Button>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
}
